import React from 'react';
import { Typography } from '@material-ui/core';
import { ImageSlide } from './image.slide';

export const Manager3Slide = () => (
  <ImageSlide
    src='https://storage.googleapis.com/bestselfy-static/onboarding/manager-onboarding-3.svg'
    alt='automated coaching'
    title='automated coaching'
  >
    <Typography variant='h1' component='h2'>
      Automated coaching for your team
    </Typography>

    <Typography>
      Support your employees and help them becoming more happy, engaged, and
      successful in the flow of work.
    </Typography>
  </ImageSlide>
);
